import axios from "axios";

const BASE = process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1/access";
const BASE_AUTH = process.env.REACT_APP_BACKEND_BASE_URL+"/api/v1";

export const fetchRoles = async () => {
  const res = await axios.get(
    `${BASE}/roles`,
    {
            headers: {
                "x-source-system": "web",
            },
        }
);
  return res.data.data;
};

export const fetchPermissions = async () => {
  const res = await axios.get(
    `${BASE}/permissions`,
    {
            headers: {
                "x-source-system": "web",
            },
        }
);
  return res.data.data;
};

export const createRole = async (payload) => {
  return axios.post(`${BASE}/create/role`, payload);
};

export const createPermission = async (payload) => {
  return axios.post(`${BASE}/create/permissions`, payload);
};

export const fetchPermissionsByRole = async (roleId) => {
    console.log("ROLE"+roleId);
  const res = await axios.post(
    `${BASE}/permissions/by/role`,
    {roleId: roleId},
         {
            headers: {
                "x-source-system": "web",
            },
        }
);
console.log("PERMISSION DATA "+res.data)
  return res.data.data;
};

export const fetchRolesByPermission = async (permissionId) => {
    console.log("PERMISSION"+permissionId);
  const res = await axios.post(
    `${BASE}/roles/by/permission`,
    {permissionId: permissionId},
         {
            headers: {
                "x-source-system": "web",
            },
        }
);
console.log("ROLE DATA "+res.data.data)
  return res.data.data;
};

export const attachRolesToUser = async (payload) => {
    console.log(payload);
  const res = await axios.post(
    `${BASE_AUTH}/auth/users/roles/attach`,
    payload,
    {
        headers:{
            "Content-Type": "application/json",
        }
    }
  );
  return res.data;
};